import axios from "src/configs/axios";
import baseAxios from "axios";

const operations = {
  fetchProducts: async (
    page = 1,
    searchKey = "",
    products = [],
    product_store = "",
    categories = [],
    price = "DESC"
  ) => {
    const reqBody = {
      search: searchKey,
      products,
      product_store,
      categories,
      price,
    };
    const { data } = await axios.post(`/products?page=${page}&per_page=30`, {
      ...reqBody,
    });
    return data;
  },
  fetchProductCategories: async () => {
    // const reqBody = categories.length > 0 ? {categories} : {}
    try {
      const { data } = await axios.get("/products-categories", {});
      if (data) {
        return data;
      } else {
        throw "no data";
      }
    } catch (err) {
      throw err;
    }
  },
  fetchCategories: async (categories) => {
    const reqBody = categories.length > 0 ? { categories } : {};
    try {
      const { data } = await axios.post("/categories", { ...reqBody });
      if (data) {
        return data;
      } else {
        throw "no data";
      }
    } catch (err) {
      throw err;
    }
  },
  fetchProduct: async (productCode, domain = "amazon.ae", url) => {
    if (url === "") {
      url = productCode?.startsWith("ir")
        ? `/${productCode.replace("-", "/")}?th=1&psc=1`
        : domain === "amazon.ae"
        ? `https://www.amazon.ae/${productCode.replace("-", "/")}?th=1&psc=1`
        : `https://amzn.eu/d/${productCode.replace("dp-", "")}`;
    } else {
      try {
        if (url?.includes("amzn.eu/d")) {
          url = decodeURIComponent(url);
        } else {
          url = decodeURIComponent(
            url + (url?.includes("?") ? "&language=en_AE" : "?language=en_AE")
          );
        }
      } catch (error) {
        console.log(error);
      }
    }

    const { data } = await axios.post("/search", { url }, { timeout: 90000 });
    // if (data?.data?.price) {
    //   let product = data.data;
    //   const { price: productPrice } = product;
    //   const price = {
    //     ...productPrice,
    //     wage: productPrice.wage / 2,
    //     total_price: productPrice.total_price - productPrice.wage / 2,
    //   };
    //   product.price = price;
    //   return { ...data, data: product };
    // }
    // console.log(data);
    return data;
  },
  fetchNamshiProduct: async (url) => {
    try {
      const { data } = await axios.post(
        `/namshi-product`,
        { url },
        { timeout: 90000 }
      );
      return data;
    } catch (err) {
      throw err;
    }
  },
  fetchNamshiProductList: async (url) => {
    try {
      const { data } = await axios.get(`/namshi-list`, {
          params: {
              url,
          }
      });
      return data;
    } catch (err) {
      throw err;
    }
  },
  fetchNikeuaeProduct: async (url) => {
    try {
      const { data } = await axios.post(
        `/nikeuae-product`,
        { url },
        { timeout: 90000 }
      );
      return data;
    } catch (err) {
      throw err;
    }
  },
  fetchAdidasuaeProduct: async (url) => {
    try {
      const { data } = await axios.post(
        `/adidasuae-product`,
        { url },
        { timeout: 90000 }
      );
      return data;
    } catch (err) {
      throw err;
    }
  },
  fetchVperfumeuaeProduct: async (url) => {
    try {
      const { data } = await axios.post(
        `/v-perfume-product`,
        { url },
        { timeout: 90000 }
      );
      return data;
    } catch (err) {
      throw err;
    }
  },
  fetchSephorauaeProduct: async (url) => {
    try {
      const { data } = await axios.post(
        `/sephorauae-product`,
        { url },
        { timeout: 90000 }
      );
      return data;
    } catch (err) {
      throw err;
    }
  },
  fetchSSsportuaeProduct: async (url) => {
    try {
      const { data } = await axios.post(
        `/sssportuae-product`,
        { url },
        { timeout: 90000 }
      );
      return data;
    } catch (err) {
      throw err;
    }
  },
  fetchNoonUaeProduct: async (url) => {
    try {
      const { data } = await axios.post(
        `/noonuae-product`,
        { url },
        { timeout: 90000 }
      );
      return data;
    } catch (err) {
      throw err;
    }
  },
  fetchProductPrice: async ({
    productInfo,
    delivery_price,
    price,
    productId = 0,
    url = "",
  }) => {
    try {
      const { data } = await axios.post(
        `/generate-price`,
        {
          productInfo,
          delivery_price,
          price,
          product_id: productId,
          url: url,
        },
        { timeout: 90000 }
      );
      return data;
    } catch (err) {
      throw err;
    }
  },
  updateProduct: async (productCode, domain = "amazon.ae") => {
    const url = productCode?.startsWith("ir")
      ? `/${productCode.replace("-", "/")}?th=1`
      : domain === "amazon.ae"
      ? `https://www.amazon.ae/${productCode.replace("-", "/")}?th=1&psc=1`
      : `https://amzn.eu/d/${productCode.replace("dp-", "")}`;

    const { data } = await axios.post("/search", { url });

    return data;
  },
};

export default operations;
